import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { Lang } from '../../../types/common-types'
import { State } from '../../../state-actions-reducers'
import styles from './SocialLinksInput.module.scss'
import TextInput from '../TextInput/TextInput'
import SelectInput from '../SelectInput/SelectInput'
import DeleteButton from '../../../shared/Buttons/DeleteButton'
import AddButton from '../../../shared/Buttons/AddButton'
import { socialLinksOptions } from '../../../content/socialLinks'

interface Props {
  lang: Lang
  accountForm: any
}
/* THE COMPONENT */
export default function SocialLinksInput({
  lang,
  accountForm,
}: Props) {
  const { watch, setValue, formState: { errors } } = useFormContext<State>()
  const state = watch()

  const [socialLinksCount, setSocialLinksCount] = useState(
    state.additionalLinksDescription.length || 1
  )
  const socialLinks = () => {
    let linksList = []
    for (let i = 0; i < socialLinksCount; i++) {
      linksList.push(
        <div
          className={styles.socialLinksRow + ' ' + 'row'}
          key={`socialLinksRow-${i}`}
        >
          <div className="col-4 col-xs-12">
            <SelectInput
              testName={`additionalLinksDescription-${i}`}
              testErrorName={`error-additionalLinksDescription-${i}`}
              noOptionsMessage={
                accountForm.additionalLinksDescription.placeholder
              }
              options={socialLinksOptions}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.additionalLinksDescription}
              onChange={additionalLinksDescription => {
                setValue(
                  'additionalLinksDescription',
                  i < state.additionalLinksDescription.length
                    ? state.additionalLinksDescription.map((item, key) =>
                        key === i ? additionalLinksDescription : item
                      )
                    : state.additionalLinksDescription.concat(additionalLinksDescription),
                  { shouldDirty: true }
                )
              }}
              valid={!errors.additionalLinksDescription}
              value={state.additionalLinksDescription[i]}
            />
          </div>
          <div className="col-6 col-xs-12">
            <TextInput
              testName={`additionalLinks-${i}`}
              testErrorName={`error-additionalLinks-${i}`}
              disabled={!state.agreed || !state.additionalLinksDescription[i]}
              lang={lang}
              content={accountForm.socialLink}
              onChange={additionalLink => {
                additionalLink = additionalLink.replace(
                  /[^A-Za-z0-9\<\>\@\!\#\$\%\^\&\*\(\)\_\+\[\]\{\}\?\:\;\|\'\"\,\.\/\~\`\\\-\=\'\ ]/gi,
                  ''
                )
                setValue(
                  'additionalLinks',
                  i < state.additionalLinks.length
                    ? state.additionalLinks.map((item, key) =>
                        key === i ? additionalLink : item
                      )
                    : state.additionalLinks.concat(additionalLink),
                  { shouldDirty: true }
                )
              }}
              valid={!errors.additionalLinks}
              value={state.additionalLinks[i]}
            />
            {i > 0 ? (
              <>
                <DeleteButton
                  testName="deleteSocialLink"
                  className={styles.socialLinksDeleteButton}
                  onClick={() => {
                    setValue(
                      'additionalLinksDescription',
                      state.additionalLinksDescription.filter((_, index) => index !== i),
                      { shouldDirty: true }
                    )
                    setValue(
                      'additionalLinks',
                      state.additionalLinks.filter((_, index) => index !== i),
                      { shouldDirty: true }
                    )
                    setSocialLinksCount(socialLinksCount - 1)
                  }}
                />
                <button
                  data-test-id="deleteSocialLink"
                  className={styles.socialLinksMobileDeleteButton}
                  onClick={() => {
                    setValue(
                      'additionalLinksDescription',
                      state.additionalLinksDescription.filter((_, index) => index !== i),
                      { shouldDirty: true }
                    )
                    setValue(
                      'additionalLinks',
                      state.additionalLinks.filter((_, index) => index !== i),
                      { shouldDirty: true }
                    )
                    setSocialLinksCount(socialLinksCount - 1)
                  }}
                >
                  Удалить
                </button>
              </>
            ) : null}
          </div>
        </div>
      )
    }
    return linksList
  }
  return (
    <div className="form-group">
      <div className="row">
        <div className="col-12 col-xs-12">
          <h3>{accountForm.stepTwoSocialTitle[lang]}</h3>
        </div>
      </div>
      {socialLinks()}
      <div className="row">
        <div className="col-12 col-xs-12">
          <div
            data-test-id="addSocialLink"
            className={styles.addButtonBox}
            onClick={() => {
              console.log(socialLinksCount)
              setSocialLinksCount(socialLinksCount + 1)
              setValue(
                'additionalLinksDescription',
                state.additionalLinksDescription.concat(''),
                { shouldDirty: true }
              )
              setValue(
                'additionalLinks',
                state.additionalLinks.concat(''),
                { shouldDirty: true }
              )
            }}
          >
            <AddButton />
            <span>{accountForm.socialLinksButton[lang]}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
